import {
  Select,
  Tooltip,
  Tag,
  Icon,
  AutoComplete,
  message,
} from 'antd';
import { useState, useEffect } from 'react';

import axios from 'axios';
import { backendUrl } from '@/utils/utils';

import moment from 'moment-timezone';
moment.tz.setDefault("Asia/Taipei");

import styles from './common.less';

const {Option} = Select;

export const distinctPush = (arr, ele)=>{
  const push = (arr, ele)=>{
    if(!arr.includes(ele)){
      arr.push(ele)
    }
  }
  if(Array.isArray(ele)){
    ele.forEach(v=>push(arr,v))
  }else{
    push(arr, ele)
  }
}

export const pull = (arr, eles)=>{
  return arr.filter(v=>!eles.includes(v));
}

export const time_options = [
  (<Option key="06:00" value="06:00">06:00</Option>),
  (<Option key="06:30" value="06:30">06:30</Option>),
  (<Option key="07:00" value="07:00">07:00</Option>),
  (<Option key="07:30" value="07:30">07:30</Option>),
  (<Option key="08:00" value="08:00">08:00</Option>),
  (<Option key="08:30" value="08:30">08:30</Option>),
  (<Option key="09:00" value="09:00">09:00</Option>),
  (<Option key="09:30" value="09:30">09:30</Option>),
  (<Option key="10:00" value="10:00">10:00</Option>),
  (<Option key="10:30" value="10:30">10:30</Option>),
  (<Option key="11:00" value="11:00">11:00</Option>),
  (<Option key="11:30" value="11:30">11:30</Option>),
  (<Option key="12:00" value="12:00">12:00</Option>),
  (<Option key="12:30" value="12:30">12:30</Option>),
  (<Option key="13:00" value="13:00">13:00</Option>),
  (<Option key="13:30" value="13:30">13:30</Option>),
  (<Option key="14:00" value="14:00">14:00</Option>),
  (<Option key="14:30" value="14:30">14:30</Option>),
  (<Option key="15:00" value="15:00">15:00</Option>),
  (<Option key="15:30" value="15:30">15:30</Option>),
  (<Option key="16:00" value="16:00">16:00</Option>),
  (<Option key="16:30" value="16:30">16:30</Option>),
  (<Option key="17:00" value="17:00">17:00</Option>),
  (<Option key="17:30" value="17:30">17:30</Option>),
  (<Option key="18:00" value="18:00">18:00</Option>),
  (<Option key="18:30" value="18:30">18:30</Option>),
  (<Option key="19:00" value="19:00">19:00</Option>),
  (<Option key="19:30" value="19:30">19:30</Option>),
  (<Option key="20:00" value="20:00">20:00</Option>),
  (<Option key="20:30" value="20:30">20:30</Option>),
  (<Option key="21:00" value="21:00">21:00</Option>),
  (<Option key="21:30" value="21:30">21:30</Option>),
  (<Option key="22:00" value="22:00">22:00</Option>),
  (<Option key="22:30" value="22:30">22:30</Option>),
  (<Option key="23:00" value="23:00">23:00</Option>),
  (<Option key="23:30" value="23:30">23:30</Option>),
];

export const gs = (xs, sm, md, lg, xl) => ({xs, sm, md, lg, xl})

export const gs_12_12_6 = gs(12, 12, 6, 6, 6);
export const gs_24_12_6 = gs(24, 12, 6, 6, 6);
export const gs_24_8_8 = gs(24, 8, 8, 8, 8);
export const gs_12_8_8 = gs(12, 8, 8, 8, 8);

export const cvtTime = (din, tin="0:0") =>{
  const d = new Date(din)
  // tin 可能是 null/空字串（場次未填開始時間）；預設參數只擋 undefined，故再補一層。
  const t = (tin || "0:0").split(':')
  return new Date(d.getYear(), d.getMonth(), d.getDate(), t[0], t[1]);
}

export const genSubmitedTag = (panel)=> <Tooltip key={panel} placement="topLeft" title={panelsConfig[panel].name}>
  <Tag color={panelsConfig[panel].color} className={styles.submitedTag}>{panelsConfig[panel].short}</Tag>
  </Tooltip>;

export const genBuyItmesTag = (d)=> {
  // 顯示名以 buyItems.display 為準（例：buyItems_留聲機 → 實體留聲機，與手機影音留聲機區別）；查無則去前綴
  const name = (buyItems.find(b=>b.name===d) || {}).display || d.substr("buyItems_".length);
  return <Tooltip key={d} placement="topLeft" title={name}>
    <Tag color="grey" className={styles.submitedTag}>{name}</Tag>
  </Tooltip>;
}

export const stopPropagation = function(e){
  e.stopPropagation();
  e.nativeEvent.stopImmediatePropagation();
}

export const phoneParse = (str='')=>{
  const regex = /([^0-9^\r^\n]+)([0-9-]{10,12})[ $]?/gm;
  let m;
  let names = [];
  while ((m = regex.exec(str)) !== null) {
      if (m.index === regex.lastIndex) {
          regex.lastIndex++;
      }
      names.push(m);
  }
  // const phones = names.map((e,idx)=>(<a key={`phone_${idx}`} onClick={stopPropagation} href={`tel:${e[2]}`}>✆{e[1]} </a>));
  const remains = str.replace(regex, '').trim();
  const regex2 = /^.+$/gm;
  let names2 = [];
  while ((m = regex2.exec(remains)) !== null) {
      if (m.index === regex.lastIndex) {
        regex2.lastIndex++;
      }
      names2.push(m);
  }

  return [
    ...names.map((e,idx)=>(<a key={`phone_${idx}`} onClick={stopPropagation} href={`tel:${e[2]}`}>✆{e[1]} </a>)),
    ...names2.map((e,idx)=>(<span key={`name_${idx}`} onClick={stopPropagation}>✪{e} </span>))
  ];

  // if(str.replace(regex, '').trim()!==''){
  //   return str; //`@${str.replace(regex, '').trim()}@`;
  // }else{
  //   return names.map((e,idx)=>(<a key={`phone_${idx}`} onClick={stopPropagation} href={`tel:${e[2]}`}>✆{e[1]} </a>));
  // }
}

export const machineParse = (str='')=>{
  const regex = /[*xX×]([0-9]+)/gm;
  let m;
  let arr = [];
  while ((m = regex.exec(str)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
          regex.lastIndex++;
      }
      arr.push(parseInt(m[1]));
      // // The result can be accessed through the `m`-variable.
      // m.forEach((match, groupIndex) => {
      //     console.log(`Found match, group ${groupIndex}: ${match}`);
      // });
  }
  return arr.reduce((a,b)=>a+b, 0);
}

export const machineShellParse = (str='')=>{
  const regex = /([^ ^、^\,^\d]+)[*xX×]([0-9]+)/gm;
  let m;
  let arr = [];
  let ret = {}
  while ((m = regex.exec(str)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
          regex.lastIndex++;
      }
      if(!ret.hasOwnProperty(m[1])){
        ret[m[1]] = 0;
      }
      ret[m[1]] += parseInt(m[2]);
      // arr.push(parseInt(m[1]));
      // // The result can be accessed through the `m`-variable.
      // m.forEach((match, groupIndex) => {
      //     console.log(`Found match, group ${groupIndex}: ${match}`);
      // });
  }
  return ret;
  // return arr.reduce((a,b)=>a+b, 0);
}
export const phoneParse_strict = (str='')=>{
  const regex = /([^0-9]+)([0-9-]{10,12})[ $]?/gm;
  let m;
  let names = [];
  while ((m = regex.exec(str)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
          regex.lastIndex++;
      }
      names.push(m);
      // // The result can be accessed through the `m`-variable.
      // m.forEach((match, groupIndex) => {
      //     console.log(`Found match, group ${groupIndex}: ${match}`);
      // });
  }
  if(str.replace(regex, '').trim()!==''){
    return str; //`@${str.replace(regex, '').trim()}@`;
  }else{
    return names.map((e,idx)=>(<a key={idx} onClick={stopPropagation} href={`tel:${e[2]}`}>✆{e[1]} </a>));
  }
}

export const customerVisible = (title="客戶可見", key="k")=> <Tooltip key={key} placement="topLeft" title={title}>
      <Icon type="eye" theme="twoTone" twoToneColor="#eb2f96" />
  </Tooltip>;

export const genSubmitedPanel = (panels)=> sortBy(panels, p=>panelsConfig[p].rank).map(genSubmitedTag)
export const genOrderStatePanel = ({
  orderPrinter, orderPhotobooth, orderInvitation, basicId, cfgWebUpload, orderMontage, games, quizs,
  gameEnabled, cfgMatt, buy_items=[], orderWine, orderPerfume, orderPaipaiyun, orderBoothPlace, cfgAnime, cfgAlbumDirect, orderVideoMessage,
})=> [
  basicId ? genSubmitedTag('basicId') : undefined,
  orderPrinter ? genSubmitedTag('orderPrinter') : undefined,
  cfgAlbumDirect ? genSubmitedTag('cfgAlbumDirect') : undefined,
  orderPhotobooth ? genSubmitedTag('orderPhotobooth') : undefined,
  orderInvitation ? genSubmitedTag('orderInvitation') : undefined,
  cfgWebUpload ? genSubmitedTag('cfgWebUpload') : undefined,
  orderMontage ? genSubmitedTag('orderMontage') : undefined,
  gameEnabled && games && games.length>0 ? genSubmitedTag('games') : undefined,
  cfgMatt ? genSubmitedTag('matt') : undefined,
  quizs > 0 ? genSubmitedTag('quizs') : undefined,
  orderWine ? genSubmitedTag('wine') : undefined,
  orderPerfume ? genSubmitedTag('perfume') : undefined,
  orderPaipaiyun ? genSubmitedTag('paipaiyun') : undefined,
  orderVideoMessage ? genSubmitedTag('vmsg') : undefined,
  orderBoothPlace ? genSubmitedTag('boothplace') : undefined,
  cfgAnime ? genSubmitedTag('anime') : undefined,
  ...buy_items.map(bi=>genBuyItmesTag(bi))
]

export const genOrderState = (d) => ({
  ...d,
  orderBoothPlace:  (d.buy_items||[])?.includes("buyItems_拍照亭")
})

export const panelsConfig = {
  basic_info: {
    name: '基本資訊',
    short: '基',
    color: 'magenta',
    rank: 0,
  },
  activity: {
    name: '活動設定',
    short: '設',
    color: 'orange',
    rank: 1,
  },
  material: {
    name: '邊框素材',
    short: '框',
    color: 'green',
    rank: 2,
  },
  offtext: {
    name: '謝客詞',
    short: '謝',
    color: 'cyan',
    rank: 3,
  },
  activity_confirm: {
    name: '行前確認',
    short: '確',
    color: 'blue',
    rank: 4,
  },
  payment: {
    name: '線上禮金',
    short: '金',
    color: 'yellow',
    rank: 5,
  },
  game_setting: {
    name: '遊戲設定',
    short: '遊戲',
    color: 'yellow',
    rank: 5,
  },
  montage_setting: {
    name: '蒙太奇設定',
    short: '蒙設',
    color: 'yellow',
    rank: 5,
  },

  try_printer: {
    name: '體驗拍貼系統',
    short: '體',
    color: 'red',
    rank: -5,
  },
  orderPrinter: {
    name: '訂購拍貼機',
    short: '拍',
    color: 'magenta',
    rank: -4,
  },
  orderInvitation: {
    name: '訂購電子喜帖',
    short: '帖',
    color: 'blue',
    rank: -3,
  },
  basicId: {
    name: '已產生帳號',
    short: '官',
    color: 'green',
    rank: -2,
  },
  cfgWebUpload: {
    name: 'MINI版',
    short: 'MINI',
    color: 'blue',
    rank: -1,
  },
  orderMontage: {
    name: '訂購蒙太奇',
    short: '蒙太奇',
    color: 'cyan',
    rank: 0,
  },
  orderPhotobooth: {
    name: '訂購韓式拍貼',
    short: '韓',
    color: 'red',
    rank: 0,
  },
  matt: {
    name: 'AI去背',
    short: 'AI',
    color: 'gold',
    rank: 0,
  },
  games: {
    name: '使用遊戲',
    short: '抽獎',
    color: 'geekblue',
    rank: -1,
  },
  cfgAlbumDirect: {
    name: '美照搜集器',
    short: '美照',
    color: 'red',
    rank: -2,
  },
  anime: {
    name: '使用AI畫家',
    short: 'AI畫家',
    color: 'red',
    rank: -2,
  },
  quizs: {
    name: '使用快問快答',
    short: '問答',
    color: 'purple',
    rank: -2,
  },
  wine: {
    name: '點點酒',
    short: '點酒',
    color: 'purple',
    rank: -3,
  },
  boothplace: {
    name: '拍照亭',
    short: '亭',
    color: 'green',
    rank: -4,
  },
  vmsg: {
    name: '手機影音留聲機',
    short: '手機留聲機',
    color: 'cyan',
    rank: -4,
  },
}

export const panelsList = Object.keys(panelsConfig).map(e=>({value: e, ...panelsConfig[e]}))
export const panelsOptions = panelsList.map(e=>((<Option key={e.value} value={e.value}>{e.name}</Option>)))

export const userEditableName = {
  'date': '活動日期',
  'title': '官方帳號名稱',
  'groom_name': '新郎姓名',
  'bride_name': '新娘姓名',
  'groom_ename': '新郎英文名',
  'bride_ename': '新娘英文名',
  'frames_material': '邊框設定',
  'start_time': '開始時間',
  'end_time': '結束時間',
  'contact_it': '故障排除',
  'contact_location': '婚企(場地)',
  'contact_lottery': '抽獎人',
  'contact_order': '訂購人',
  'contact_presenter': '主持人',
  'location_addr': '宴客地址',
  'location_area': '宴客地區',
  'location_readable': '宴客地點(飯店/廳別)',
  'card_num': '桌卡數量',
  'frames_word': '文字框',
  'frames_person': '人物框',
  'frames_korean': '韓式框',
  // 'frameOrder': '邊框順序',
  'defaultPrintNumber': '列印額度',

  'locationGoogleUrl': '宴客地圖網址(電子喜帖',

  'material_note': '邊框備註',
  'tail_fee_last5': '轉帳末5碼',
  'tail_fee_date': '轉帳日期',

  'customerCheckFrame': '確認邊框',
  'customerCheckLottery': '確認抽獎',
  'customerCheckPower': '確認電源',
  'customerCheckDistance': '確認距離',
  'customerCheckComputer': '確認電腦',
  'customerCheckMeal': '確認餐點',
  'customerCheckOverflow': '確認超時處理方式',
  'customerCheckOverflowSelect': '超時處理方式',
  'customerCheckCoupon': '確認提供加值碼',
  'customerCheckCouponSelect': '確認提供加值碼選項',
  "customerCheckPropaganda": '確認桌宣',
  "customerCheckPropagandaSelect": '確認桌宣選項',
  "customerCheckServiceProvider": '確認服務商',
  "customerCheckContentNotControl": '私人照片',
  "customerCheckMontage": '確認蒙太奇',
  "customerCheckSideShot": '確認側拍',
  "customerCheckSideShotSelect": '確認側拍選項',
  "customerCheckQuiz": '確認快問快答',

  'offText': '謝客詞',
  'offTextTime': '謝客詞時間',
  'try_printer': '體驗拍貼系統',
}

// export const orderItemOptions = {
//   'date': '手翻相冊',
//   'title': '號名稱',
//   'groom_name': '新郎姓名',
// }

export const userEditableList = Object.keys(userEditableName);

const transTitle = key => userEditableName[key] ? userEditableName[key] : key

export const userEditableDesc = Object.keys(userEditableName).map(name=>({
  key: name,
  title: transTitle(name),
  description: name,
  disabled: false,
}))

export const two_val_check = (key) => (data, ref)=>ref[key] === undefined ? data[key] : ref[key]

export const makeid = (length) => {
   var result           = '';
   var characters       = 'abcdefghijklmnopqrstuvwxyz';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

export const invitation_menu_config = [
  {
    key: 'free0-map-gallery-printer',
    title: '粉紅-導航-婚紗',
    fn: 'free0-map-gallery-printer'
  },
  {
    key: 'free0-map-gallery-survey-printer',
    title: '粉紅-導航-婚紗-問卷',
    fn: 'free0-map-gallery-survey-printer'
  },
  {
    key: 'free0-map-printer',
    title: '粉紅-導航',
    fn: 'free0-map-printer'
  },
  {
    key: 'free0-map-survey-printer',
    title: '粉紅-導航-問卷',
    fn: 'free0-map-survey-printer'
  },
  {
    key: 'free1-map-gallery-printer',
    title: '大約-導航-婚紗',
    fn: 'free1-map-gallery-printer'
  },
  {
    key: 'free1-map-gallery-survey-printer',
    title: '大約-導航-婚紗-問卷',
    fn: 'free1-map-gallery-survey-printer'
  },
  {
    key: 'free1-map-printer',
    title: '大約-導航',
    fn: 'free1-map-printer'
  },
  {
    key: 'free1-map-survey-printer',
    title: '大約-導航-問卷',
    fn: 'free1-map-survey-printer'
  },
  {
    key: 'free2-map-survey-printer',
    title: '中式-導航-問卷',
    fn: 'free2-map-survey-printer'
  },
  {
    key: 'free2-map-gallery-printer',
    title: '中式-導航-婚紗',
    fn: 'free2-map-gallery-printer'
  },
  {
    key: 'free2-map-gallery-survey-printer',
    title: '中式-導航-婚紗-問卷',
    fn: 'free2-map-gallery-survey-printer'
  },
  {
    key: 'free2-map-printer',
    title: '中式-導航',
    fn: 'free2-map-printer'
  },
  {
    key: 'free3-map-gallery-printer',
    title: '大栽-導航-婚紗',
    fn: 'free3-map-gallery-printer'
  },
  {
    key: 'free3-map-gallery-survey-printer',
    title: '大栽-導航-婚紗-問卷',
    fn: 'free3-map-gallery-survey-printer'
  },
  {
    key: 'free4-map-gallery-survey-printer',
    title: '直簡-導航-婚紗-問卷',
    fn: 'free4-map-gallery-survey-printer'
  },
  {
    key:'f0-map',
    title: '粉紅-導航',
    fn:'f0-map'
  },
  {
    key:'f0',
    title: '粉紅-問卷+導航',
    fn:'f0'
  },
  {
    key:'f0',
    title: '粉紅-問卷+導航',
    fn:'f0'
  },
  {
    key:'f0-gallery-printer',
    title: '粉紅-婚紗+問卷+導航',
    fn:'f0-gallery-printer'
  },
  /*
  {
    key:'a1',
    title: '喜帖-大理石',
    fn:'a1'
  },
  {
    key:'a2',
    title: '婚禮-中式',
    fn:'a2'
  },
  {
    key:'a3',
    title: '婚禮-高雅',
    fn:'a3'
  },
  {
    key:'vend_romancelife',
    title: '廠商-浪漫一生',
    fn:'vend_romancelife'
  },
  {
    key:'a4',
    title: '婚禮-大理石2',
    fn:'a4'
  },
  {
    key:'p1',
    title: '喜帖-大理石',
    fn:'p1'
  },*/
];

export const menu_config = [
    {
      key:'menu_gallery_invitation_quiz',
      title: '喜帖+婚禮+婚紗+快問',
      fn:'menu_gallery_invitation_quiz.jpg'
    },
    {
      key:'menu_gallery_invitation',
      title: '喜帖+婚紗',
      fn:'menu_gallery_invitation.jpg'
    },
    {
      key:'menu_gallery_quiz',
      title: '婚紗+快問',
      fn:'menu_gallery_quiz.jpg'
    },
    {
      key:'menu_gallery',
      title: '婚紗',
      fn:'menu_gallery.jpg'
    },
    {
      key:'menu_simple',
      title: '基本',
      fn:'menu_simple.jpg'
    },
    {
      key:'menu_lottery',
      title: '抽獎(有主題抽獎才選這個)',
      fn:'menu_lottery.jpg'
    },
    {
      key:'menu_activity',
      title: '[活動]抽獎+快訊(有主題抽獎才選這個)',
      fn:'menu_activity.jpg'
    },
    {
      key:'menu_activity_simple',
      title: '活動場',
      fn:'menu_activity_simple.jpg'
    },
    {
      key:'menu_lottery_gallery_invitation',
      title: '喜帖+抽獎+婚紗(有主題抽獎才選這個)',
      fn:'menu_lottery_gallery_invitation.jpg'
    },
    {
      key:'menu_lottery_gallery',
      title: '抽獎+婚紗(有主題抽獎才選這個)',
      fn:'menu_lottery_gallery.jpg'
    },
    {
      key:'menu_lottery_gallery_quiz',
      title: '抽獎+婚紗+快問(有主題抽獎才選這個)',
      fn:'menu_lottery_gallery_quiz.jpg'
    },
    {
      key:'menu_lottery_gallery_invitation_quiz',
      title: '喜帖+抽獎+婚紗+快問(有主題抽獎才選這個)',
      fn:'menu_lottery_gallery_invitation_quiz.jpg'
    },
  ];



export const default_menu_config = [
  {
    key:'',
    title: '無選單'
  },
  {
    key:'printer',
    title: '拍拍印',
  },
  {
    key:'invitation',
    title: '電子喜帖',
  },
];

export const buyItems = [
  { name: "buyItems_手翻相冊", display:"手翻相冊", keywords:["美式手翻"] },
  { name: "buyItems_手翻相冊(韓式)", display:"手翻相冊(韓式)", keywords:["韓式手翻"] },
  // { name: "buyItems_似顏繪", display:"似顏繪" },
  { name: "buyItems_紙相框", display:"紙相框" },
  { name: "buyItems_拍照亭", display:"拍照亭" },
  { name: "buyItems_時光桌曆", display:"時光桌曆" },
  { name: "buyItems_婚後蒙太奇", display:"婚後蒙太奇", keywords:["婚後蒙太奇", "蒙太奇紀念"] },
  // { name: "buyItems_美顏燈", display:"美顏燈" },
  { name: "buyItems_婚後30張", display:"婚後30張", keywords:["30張"] },
  { name: "buyItems_心型簽名框", display:"心型簽名框", keywords:["心型相框"] },
  { name: "buyItems_敲敲杯", display:"敲敲杯", keywords:["敲敲杯"] },
  { name: "buyItems_星光燈+拍立得平板", display:"星光+平板", keywords:["星光", "美顏燈", "平板燈", "美燈", "網紅燈"]},
  { name: "buyItems_留聲機", display:"實體留聲機" },
  { name: "buyItems_賓客似顏繪", display:"賓客似顏繪", keywords:["賓客似顏繪", "AI似顏繪"] },
  { name: "buyItems_新人似顏繪", display:"新人似顏繪", keywords:["新人似顏繪"] },

  { name: "buyItems_韓式木框(二連)", display:"韓式木框(二連)", keywords:["韓式木框"] },
  { name: "buyItems_美式木框(三連)", display:"美式木框(三連)", keywords:["美式木框"]  },
  { name: "buyItems_韓式水晶框", display:"韓式水晶框" },
  { name: "buyItems_韓式水晶框(二連)", display:"韓式水晶框(二連)" },

  { name: "buyItems_香氛瓶", display:"香氛瓶", keywords:["香氛瓶", "香氛", "香氛小物"] },

  // 2026 展覽訂單好禮/加價購(expoOrder backendMap 會寫入這些值)
  { name: "buyItems_水晶冰箱貼", display:"水晶冰箱貼", keywords:["冰箱貼"] },
  { name: "buyItems_WeddingStory精裝書", display:"WeddingStory精裝書", keywords:["精裝書", "wedding story"] },
  { name: "buyItems_時光拍拍燈", display:"時光拍拍燈", keywords:["時光拍拍燈", "拍拍燈"] },
  { name: "buyItems_專屬鑰匙圈", display:"專屬鑰匙圈" },
  { name: "buyItems_客製調酒名稱", display:"客製調酒名稱" },
  { name: "buyItems_酒杯裝飾", display:"酒杯裝飾" },
  { name: "buyItems_精選客製套組", display:"精選客製套組" },
  { name: "buyItems_針織花束", display:"針織花束", keywords:["針織花"] },
  { name: "buyItems_香香機", display:"香香機" },
]
export const buyItemsOptions = buyItems.map(d=><Option key={d.name} value={d.name} label={d.display}>{d.display}</Option>);

// 「系統出貨備註」清單。出貨單上的表格 + 小秘書後台 CardLive 都讀這個 helper，
// 兩邊呈現完全一致。回傳陣列 [{ label, memo }] — label 是項目名、memo 是該項
// 的補充說明（例：韓式 → "星光燈+平板+展示架"）。
export const computeShippingItems = (activity) => {
  if (!activity) return [];
  const items = [];
  // buy_items：去掉前綴後直接列；過濾掉已用其他欄位專門呈現的（賓客似顏繪 走 cfgAnime 那行）
  (activity.buy_items || [])
    .map(d => (d || '').replace('buyItems_', ''))
    .filter(c => c && !['似顏繪', '婚後30張', '賓客似顏繪'].includes(c))
    .forEach(name => items.push({
      label: name,
      memo: name === '美顏燈' ? '記得帶腳架' : '',
    }));
  if (activity.orderMontage) items.push({ label: '蒙太奇', memo: '底紙+貼紙+相框' });
  if (activity.orderPhotobooth) items.push({ label: '韓式', memo: '星光燈+平板+展示架' });
  if (activity.orderNewspaper) items.push({
    label: '報紙',
    memo: 'A4特殊紙+提袋+婚報機殼+支撐架',
  });
  if (activity.orderKeychain) {
    const qk = activity.quotaKeychain;
    items.push({ label: '鑰匙圈', memo: qk === -1 ? '不限量' : `${qk || 0} 個` });
  }
  if (activity.orderLightBox) {
    const qt = activity.quotaLightBox;
    items.push({ label: '磁吸小燈箱', memo: qt === -1 ? '不限量' : `${qt || 0} 個` });
  }
  if (activity.orderMagicCard) {
    const qm = activity.quotaMagicCard;
    items.push({ label: '3D魔法動卡', memo: qm === -1 ? '不限量' : `${qm || 0} 個` });
  }
  if (activity.orderPvcCard) {
    const qp = activity.quotaPvcCard;
    items.push({ label: 'PVC證卡', memo: qp === -1 ? '不限量' : `${qp || 0} 張` });
  }
  if (activity.orderSketchRobot) {
    const qs = activity.quotaSketchRobot;
    items.push({ label: '素描機器人', memo: qs === -1 ? '不限量' : `${qs || 0} 張` });
  }
  if (activity.cfgAnime) items.push({
    label: '賓客似顏繪',
    memo: `${activity.quotaAnime || 0} 張小卡`,
  });
  return items;
};

export const gamesItems = [
  { name: "spin", display:"歡樂大轉盤" },
  { name: "ball", display:"魔幻彩球" },
  { name: "quiz", display:"快問快答" },
  { name: "ballon", display:"捧花爭奪戰" },
  { name: "lotto", display:"幸福樂透520" },
  { name: "ballon_horse", display:"賽馬爭奪戰" },
  { name: "tetris", display:"俄羅斯方塊" },
  { name: "snake", display:"貪食蛇" },
  { name: "galaxy", display:"銀河大作戰" },
  { name: "slotMachine", display:"幸福拉霸機" },
]
export const gamesItemsOptions = gamesItems.map(d=><Option key={d.name} value={d.name} label={d.display}>{d.display}</Option>);

// === planItems: loaded from backend /api/config/planItems ===
//
// Source of truth is MongoDB Config collection (key='planItems').
// On module load we kick off an async fetch; consumers that hold
// a captured array reference (e.g. <AutoComplete dataSource={planItemsOptions}>)
// can use the `usePlanItems` hook below to re-render once data arrives.
// localStorage cache provides immediate hydration after the first visit.
const PLAN_ITEMS_CACHE_KEY = 'linein_planItems_cache_v1';

const buildPlanItemsOptions = (items) => items.map(d => (
  <AutoComplete.Option key={d.name} value={d.name} label={d.name}>
    <div style={{display:'flex', alignItems: 'center'}}>
      <span className="menu_select_thumb" style={{whiteSpace:"wrap"}}>{d.name}</span>
      <img
        style={{ maxWidth: 80, maxHeight: 100,  }}
        src={d.url}
      />
    </div>
  </AutoComplete.Option>
));

const _readPlanItemsCache = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return [];
    const raw = window.localStorage.getItem(PLAN_ITEMS_CACHE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export let planItems = _readPlanItemsCache();
export let planItemsOptions = buildPlanItemsOptions(planItems);

// 依名稱過濾後重建下拉選項（如：主方案欄排除點點酒、點點酒欄只留點點酒）
export const filterPlanItemsOptions = (pred) => buildPlanItemsOptions(planItems.filter(pred));
export const isDrinkPlanItem = (p) => /點點酒/.test(String((p && p.name) || ''));

const planItemsListeners = new Set();
let planItemsLoadPromise = null;

export const loadPlanItems = (force = false) => {
  if (planItemsLoadPromise && !force) return planItemsLoadPromise;
  planItemsLoadPromise = (async () => {
    try {
      const { data } = await axios.get(`${backendUrl()}/api/config/planItems`, { withCredentials: true });
      if (data && data.success && Array.isArray(data.data)) {
        planItems = data.data;
        planItemsOptions = buildPlanItemsOptions(planItems);
        try { window.localStorage.setItem(PLAN_ITEMS_CACHE_KEY, JSON.stringify(planItems)); } catch (e) {}
        planItemsListeners.forEach(fn => fn());
      }
    } catch (e) {
      console.error('loadPlanItems failed', e);
      planItemsLoadPromise = null;
    }
    return planItems;
  })();
  return planItemsLoadPromise;
};

// AutoComplete filter for the 方案 dropdown: 依輸入文字比對方案 name 與 keywords (不分大小寫)。
// 預設 antd v3 AutoComplete 不過濾 (整份當建議清單)，故需明確帶入此 filterOption。
export const planItemsFilterOption = (inputValue, option) => {
  const q = String(inputValue || '').trim().toLowerCase();
  if (!q) return true;
  const name = String((option && option.props && option.props.value) || '');
  if (name.toLowerCase().indexOf(q) >= 0) return true;
  const item = planItems.find(p => p.name === name);
  return !!(item && Array.isArray(item.keywords)
    && item.keywords.some(k => String(k).toLowerCase().indexOf(q) >= 0));
};

export const usePlanItems = () => {
  const [, setVer] = useState(0);
  useEffect(() => {
    const fn = () => setVer(v => v + 1);
    planItemsListeners.add(fn);
    if (!planItemsLoadPromise) loadPlanItems();
    return () => planItemsListeners.delete(fn);
  }, []);
  return { planItems, planItemsOptions };
};

// Kick off load on module import
loadPlanItems();

export const orderStates = [
  {
    name:'orderPrinter',
    display: '拍貼機'
  },
  {
    name:'cfgAlbumDirect',
    display: '美照搜集器'
  },
  {
    name:'orderInvitation',
    display: '電子喜帖',
  },
  {
    name:'orderMontage',
    display: '蒙太奇',
  },
  {
    name:'orderPhotobooth',
    display: '韓式三連拍',
  },
  {
    name:'orderWine',
    display: '點點酒',
  },
  {
    name:'orderPerfume',
    display: '香香機',
  },
  {
    name:'orderPaipaiyun',
    display: '拍拍雲',
  },
  {
    name:'orderVideoMessage',
    display: '手機影音留聲機',
  },
  ...buyItems,
];

export const liffId = '1654358021-rAWyJ9bj';

export const todo_types_config ={
  '諮詢':{ display:'諮詢紀錄', color:'#fafafa', textColor:'#000' },
  '客服':{ display:'客服類待辦', color:'pink', textColor:'#820014' },
  '美工':{ display:'美工類待辦', color:'#d3adf7', textColor:'#531dab' },
  '工程':{ display:'工程類待辦', color:'#91d5ff', textColor:'#0050b3' },
  '現場':{ display:'現場類待辦', color:'#b7eb8f', textColor:'#135200' },
}
export const todo_types = Object.keys(todo_types_config);

export const activity_status_config = {
  '追蹤': { color:'yellow', },
  '體驗': { color:'pink', },
  '正常': { color:'green', },
  '完成': { color:'#8c8c8c', },
  '取消': { color:'#CCCCCC', },
  '延期': { color:'#999999', },
}
export const activity_status = Object.keys(activity_status_config);

export const activity_types_config ={
  '婚宴':{ display:'婚宴', color:'pink', },
  '活動':{ display:'活動', color:'yellow', },
  '展示':{ display:'展示', color:'green', },
  '長租':{ display:'長租', color:'blue', },
}
export const activity_types = Object.keys(activity_types_config);

export const customerTypeOptions = activity_types.map(e=><Option key={e} value={e}>{e}</Option>);
export const customerStatusOptions = activity_status.map(e=><Option key={e} value={e}>{e}</Option>);

export const preventClick = {
  onClick: (e, o)=>{
    e && e.stopPropagation && e.stopPropagation(); //e.nativeEvent.stopImmediatePropagation(); e.preventDefault();
    o && o.stopPropagation && o.stopPropagation(); //e.nativeEvent.stopImmediatePropagation(); e.preventDefault();
  }
}

export const UrlExists = url=> {
  var http = new XMLHttpRequest();
  http.open('HEAD', url, false);
  http.send();
  return http.status!=404 ? moment(http.getResponseHeader('last-modified')): false;
}

export {moment};

export const contactRateDesc = ['放棄', '未處理', '邀約體驗', '已約體驗', '已體驗，需PUSH', '已體驗，意願高', '已填單，尚未付款']


export const location_type = {
  "大台北": ["台北", "基隆", "新北"],
  "桃竹苗": ["桃園", "新竹", "苗栗"],
  "台中區": ["台中"],
  "彰投": ["彰化", "南投"],
  "南部": ["台南", "高雄", "雲林", "屏東", "嘉義"],
  "東部": ["宜蘭", "花蓮", "臺東", "台東"],
  "其他區": ["澎湖", "金門", "連江", "其他"],
};


export const timeRange = {
  'no_date': [null, null], // 不限
  'after_today':  [moment().startOf('day'), null], // '今日過後'],
  'before_today':  [null, moment().startOf('day')], // '今日以前'],
  'future_month': [moment().startOf('day'), moment().add(1, 'M').endOf('day')], // '未來一個月
  'future_week': [moment().startOf('day'), moment().add(7, 'd').endOf('day')], // '未來一個月
  'pass_week': [moment().subtract(7, 'd').startOf('day'), moment().endOf('day') ], // '上一周
  'pass_month': [moment().subtract(1, 'M').startOf('day'), moment().endOf('day') ], // '過去一個月
  'this_month': [moment().startOf('month'), moment().endOf('month') ], // '下個月
  'next_month': [moment().add(1, 'M').startOf('month'), moment().add(1, 'M').endOf('month') ], // '下個月
  'last_month': [moment().subtract(1, 'M').startOf('month'), moment().subtract(1, 'M').endOf('month') ], // '上個月
  'today': [moment().startOf('day'), moment().endOf('day')], // '今日
  // 'all': [moment({y:2000, M:1, d:1}), moment({y:2050, M:1, d:1})], // '所有']
}

export const timeRangeMapping = [
  ['no_date', '不限'],
  ['today', '今日'],

  ['future_month', '後一月'],
  ['pass_month', '前一月'],

  ['future_week', '後一周'],
  ['pass_week', '前一周'],

  ['this_month', '本月'],
  ['next_month', '下月'],
  ['last_month', '上月'],

  ['after_today', '今日後'],
  ['before_today', '今日前'],

  // ['all', '所有'],
  ['custom', '自訂'],
];

export const numberWithCommas = x => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const format_with_mod2 = (number) => {
  var n = number;
  var r = "";
  do {
      var mod = n % 1000;
      n = n / 1000;
      r = ~~mod + (!!r ? "," + r : "")
  } while (n > 1)

  var strNumber = number + "";
  var index = strNumber.indexOf(".");
  if (index > 0) {
      r += strNumber.substring(index);
  }
  return r;
}

export const ensureKeyAndPush = (d, k=default_k, def=[], v, default_k='official') => {
  if(k=='undefined' || k===undefined ){ k = default_k; }
  if (!d.hasOwnProperty(k)){ d[k]=def; }
  if(v){
    d[k].push(v);
  }
}

export const toWeekDay = d=> [0, '一', '二', '三', '四', '五', '六', '日'][d.isoWeekday()];

export const readPaperform = async (id_default="") => {
  const id = prompt("請貼上paperform id", id_default);
  if(!id || id=="") return {};

  message.loading('查詢資料中...', 0)
  const [{data:{msg, data, success}}] = await Promise.all([
    axios.get(`${backendUrl()}/api/read_order_data_by_paperform_id/?id=${id}`, {withCredentials: true}),
    loadPlanItems(),
  ]);
  console.log('data', {msg, data, success});
  message.destroy();
  if(!success){
    message.error('查詢資料發生錯誤:'+msg, 5);
  }
  const planName = planItems.reduce((acc, cur)=>{
    if(acc!=='') return acc;
    if((cur.keywords||[]).some(k=>data["方案"].indexOf(k)>=0)){
      return cur.name;
    }
    return '';
  }, '');

  const extraConfig = (planItems.find(p=>p.name==planName)||{}).config;

  const order_discount_note = (data["尾款明細"]||'').includes("團購") ? data["尾款明細"] : data["優惠內容"];

  // 合併所有可能含加購資訊的欄位，統一掃描關鍵字
  const purchaseText = [data["尾款明細"], data["加購項目"], data["加購"], data["備註"]].filter(Boolean).join(' ');
  const cfgAlbumDirect = /美照搜集器|集器/.test(purchaseText);

  const formData = {
    cfgWebUpload: false,
    groom_name: data["新郎姓名"],
    bride_name: data["新娘姓名"],
    plan: planName,
    maxGames: 2,
    date: moment(data["日期"] + " 13:00:00") || null,
    time_segment: (data["時段"]||"").split(" ")[0],
    orderDate: moment(data["下單時間"]) || null,
    note_machine:"",
    cfgMatt: true,
    orderMontage: false,
    gameEnabled: true,
    total_fee: parseInt(data["確認總金額"]?.replace(/\D/g, '')),
    tail_fee: parseInt(data["確認總金額"]?.replace(/\D/g, '')||'3000')-3000,
    tail_fee_note: data["尾款明細"],
    order_discount_note: "",
    mobile: data["手機"],
    email: data["email"],
    line_id: data["line"],
    customer_name: `${data["新郎姓名"]}&${data["新娘姓名"]}`,
    order_discount_note,
    cfgAlbumDirect,

    location_area: data["地區"].split("+")[0],
    location_readable: data["地點"],
    "title": data["官方帳號名稱"],
    "serviceBelong.source.memo": data["團購"],
    "serviceBelong.saling.memo": data["銷售業務"],
  };
  return {formData, extraConfig};
}

export const deliverNameExtra = (s='') => s.split(/[- 0]/)[0];

export const recommend_workers_gen = f => [
  [f.orderPrinter, "拍貼機", 2],
  [f.orderPhotobooth, "韓式", 2],
  [f.orderWine, "點點酒", 2],
  [f.orderPerfume, "香香機", 1],
];

// 飲料材料包裝容量定義
export const ingredientPackages = {
  '琴酒': { capacity: 1500, unit: '袋' },
  '伏特加': { capacity: 1500, unit: '袋' },
  '蘭姆酒': { capacity: 1500, unit: '袋' },
  '百香果糖漿': { capacity: 1500, unit: '袋' },
  '藍柑橘糖漿': { capacity: 1500, unit: '袋' },
  '梅酒糖漿': { capacity: 1500, unit: '袋' },
  '鹽漬櫻花糖漿': { capacity: 1500, unit: '袋' },
  '檸檬汁': { capacity: 1500, unit: '袋' },
  '白葡萄汁': { capacity: 2000, unit: '瓶' },
  '雪碧': { capacity: 2000, unit: '瓶' },
  '健酪乳酸': { capacity: 1450, unit: '瓶' },
};

/**
 * 計算飲料所需材料總量及包裝數量
 * @param {Array} wines - 飲料列表
 * @param {Number} duration - 時長（分鐘）
 * @returns {Object} 包含所需材料總量及包裝數量的對象
 */
export const calculateWineIngredients = (wines, duration) => {
  // 初始化材料需求量
  const ingredientVolumes = {};

  // 計算每種材料的總需求量（每分鐘每種飲料一杯）
  wines.forEach(wine => {
    if (wine.ingredient && Array.isArray(wine.ingredient)) {
      wine.ingredient.forEach(ingredient => {
        const name = ingredient.name;
        const volume = ingredient.volume || 0;

        if (!ingredientVolumes[name]) {
          ingredientVolumes[name] = 0;
        }

        // 累加該材料在所有時間內的需求量
        ingredientVolumes[name] += volume * duration * 60 / 30 / wines.length ; //每30秒點一杯飲料
      });
    }
  });

  // 計算每種材料需要的包裝數量
  const result = {
    totalVolumes: {}, // 總需求量
    packageCounts: {}, // 包裝數量
    packageDetails: {} // 包含單位的詳細信息
  };

  Object.keys(ingredientVolumes).forEach(name => {
    const totalVolume = ingredientVolumes[name];
    result.totalVolumes[name] = totalVolume;

    // 如果有定義包裝容量，計算需要的包裝數量
    if (ingredientPackages[name]) {
      const { capacity, unit } = ingredientPackages[name];
      const packageCount = Math.ceil(totalVolume / capacity);

      result.packageCounts[name] = packageCount;
      result.packageDetails[name] = {
        totalVolume,
        packageCount,
        capacity,
        unit
      };
    } else {
      // 如果沒有定義包裝容量，默認為1單位
      result.packageCounts[name] = Math.ceil(totalVolume);
      result.packageDetails[name] = {
        totalVolume,
        packageCount: Math.ceil(totalVolume),
        capacity: 1,
        unit: 'cc'
      };
    }
  });

  // 定義材料順序
  const materialOrder = [
    '琴酒',
    '伏特加',
    '蘭姆酒',
    '百香果糖漿',
    '藍柑橘糖漿',
    '梅酒糖漿',
    '鹽漬櫻花糖漿',
    '檸檬汁',
    '白葡萄汁',
    '雪碧',
    '健酪乳酸'
  ];

  // 將結果轉換為數組並按指定順序排序
  result.packageArr = Object.keys(result.packageDetails)
    .map(name => ({
      key: name,
      name,
      ...result.packageDetails[name],
      order: materialOrder.indexOf(name) // 添加排序索引
    }))
    .sort((a, b) => a.order - b.order); // 按順序排序

  return result;
};

// export const ensureKeyAndSet = (d, k=default_k, def=[], v, default_k='official') => {
//   if(k=='undefined' || k===undefined ){ k = default_k; }
//   if (!d.hasOwnProperty(k)){ d[k]=def; }
//   if(v){
//     d[k] [v);
//   }
// }


// 舊工作人員文字欄（note_worker）僅在 URL 帶 admin=1 時可編輯
// （canonical 已改為結構化 workers[]，文字欄為鏡像；hash router 也支援）
export const legacyWorkerEditable = () => /[?&]admin=1/.test(window.location.search + window.location.hash);
